import { FC } from 'react'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { Link } from 'react-router-dom'
import { Box, Divider } from '@mui/material'
import StatusIndicator from '../../ui/status-indicator/StatusIndicator'
import { constants } from '../../commons/constants/constants'
import { setClassNameForTable } from '../../commons/utils/utils'
import SelfServeActionItem from '../../ui/list-action-item/SelfServeActionItem'
import { RoutePath } from '../../core/routes/routePaths'
import LeaderboardOutlinedIcon from '@mui/icons-material/LeaderboardOutlined'
import { useTranslation } from 'react-i18next'
import { CampaignsInterface } from '../../campaigns/interfaces/campaigns'
import { CampaignsStatuses } from '../../campaigns/constants'
import {
  CampaignsSegmentsListColumnsForAgencies,
  CampaignsSegmentsListColumnsForTenants
} from '../constants'
import { campaignsListActionItems, setStatusColor } from '../../campaigns/utils'
import { useAppSelector } from '../../core/redux/hooks'
import { RoleType } from '../../core/routes/constants'

interface SegmentCampaignsListProps {
  campaignList?: CampaignsInterface[]
}

const SegmentCampaignsList: FC<SegmentCampaignsListProps> = ({
  campaignList
}) => {
  const {
    auth: { userType, isAgencyEnabled }
  } = useAppSelector((state) => state)

  const COLUMNS = Object.values(
    userType !== RoleType.AGENCY && isAgencyEnabled
      ? CampaignsSegmentsListColumnsForTenants
      : CampaignsSegmentsListColumnsForAgencies
  )
  const { t } = useTranslation()

  return (
    <TableContainer>
      <Table
        sx={{ minWidth: constants.GENERAL_TABLE_MIN_WIDTH }}
        aria-label='simple table'
      >
        <TableHead>
          <TableRow>
            {COLUMNS.map((column, i) => (
              <TableCell
                className={setClassNameForTable(column, i, COLUMNS)}
                key={column}
              >
                {column}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {campaignList?.map((row) => (
            <TableRow className='row-with-actions' key={row.CampaignID}>
              <TableCell className='centered-cell body-cell'>
                {row.CampaignID}
              </TableCell>
              <TableCell className='body-cell'>{row.Title}</TableCell>
              {userType !== RoleType.AGENCY && isAgencyEnabled && (
                <TableCell className='body-cell'>
                  {row.AgencyIconUrl != null && (
                    <img
                      alt='agency-icon'
                      className='rounded-image-list'
                      src={row.AgencyIconUrl}
                    />
                  )}
                  <Link to={`${RoutePath.Agencies}/${row.AgencyID ?? ''}`}>
                    {row.AgencyName}
                  </Link>
                </TableCell>
              )}
              <TableCell className='body-cell'>{row.CategoryName}</TableCell>
              <TableCell className='body-cell centered-cell'>
                {row.WebUiPosition}
              </TableCell>
              <TableCell className='body-cell centered-cell'>
                {row.status != null && (
                  <StatusIndicator
                    color={setStatusColor(row.status as CampaignsStatuses)}
                    title={row.status}
                  />
                )}
              </TableCell>
              <TableCell className='body-cell'>
                <Box className='list-actions flex-center'>
                  <SelfServeActionItem
                    path='/'
                    title={t`Analytics`}
                    icon={<LeaderboardOutlinedIcon />}
                  />
                  {campaignsListActionItems(
                    row.CampaignID?.toString() ?? ''
                  ).map((item) => {
                    return (
                      <SelfServeActionItem
                        path={item.path}
                        title={item.title}
                        icon={item.icon}
                        key={item.title}
                      />
                    )
                  })}
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Divider />
    </TableContainer>
  )
}

export default SegmentCampaignsList
